import { concat, Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Logger } from '@chr/common-javascript-logging-core';

/**
 * An RxJS operator similar to .catch.
 *
 * This will log the exception and re-throw it, giving you an
 * opportunity to handle it in your app (we don't want to just
 * swallow the exception).
 */

function withLogging() {
  return function withLogging(source) {
    var started;
    return concat(Observable.create(function (observer) {
      started = Date.now();
      observer.complete();
      return function () {};
    }), source.pipe(catchError(function (error, original) {
      var durationMs = Date.now() - started;
      Logger.logError(error, original);
      Logger.logDependency({
        durationMs: durationMs,
        statusCode: error.status,
        url: error.request.url
      });
      return throwError(error);
    }), tap(function (current) {
      var durationMs = Date.now() - started;
      Logger.logDependency({
        durationMs: durationMs,
        statusCode: current.status,
        url: current.request.url
      });
    })));
  };
}

export { withLogging };
